import { render, staticRenderFns } from "./Periodoncia.vue?vue&type=template&id=45eacd43&scoped=true&"
import script from "./Periodoncia.vue?vue&type=script&lang=ts&"
export * from "./Periodoncia.vue?vue&type=script&lang=ts&"
import style0 from "./Periodoncia.vue?vue&type=style&index=0&id=45eacd43&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45eacd43",
  null
  
)

export default component.exports